import type CanvasGroup from '@gl/lit/components/base/canvas_group/index.js';
import type CanvasNode from '@gl/lit/components/base/canvas_node/index.js';
import type CanvasElement from '@gl/lit/components/base/canvas_element/index.js';
import type CanvasConnection from '@gl/lit/components/base/canvas_connection/index.js';

type CanvasType = 'node' | 'group' | 'connection';

export const CanvasZIndex = {
  BASE_NODE: 1,
  SELECTED_NODE: 2,
} as const;

type CanvasItem =
  | Element
  | CanvasElement
  | CanvasNode
  | CanvasGroup
  | CanvasConnection
  | Node
  | EventTarget
  | null
  | undefined;

function isCanvasType<T extends CanvasItem>(
  item: CanvasItem,
  type: CanvasType
): item is T {
  return !!item && 'canvasType' in item && item.canvasType === type;
}

export const isCanvasNodeType = (item: CanvasItem): item is CanvasNode =>
  isCanvasType<CanvasNode>(item, 'node');

export const isCanvasGroupType = (item: CanvasItem): item is CanvasGroup =>
  isCanvasType<CanvasGroup>(item, 'group');

export const isCanvasConnectionType = (
  item: CanvasItem
): item is CanvasConnection =>
  isCanvasType<CanvasConnection>(item, 'connection');
